import './styles.css';
import {useState} from 'react';
import { Typography } from '@mui/material';
import pitchTestMegaData from './pitchTestsMetaData';
import TuneViolinModal from '../../common/TuneViolinModal';
import PitchTestsBeginModal from '../../common/PitchTestsBeginModal';
import PitchTestSession from '../../common/PitchTestSession';
import SEO from '../../common/SEO';

const NumQuestionsPerLevel = 10;

const PitchTestPage = () => {
  const [showTuneViolinModal, setShowTuneViolinModal] = useState(false);
  const [showBeginModal, setShowBeginModal] = useState(true);
  const [levelIndex, setLevelIndex] = useState(0);

  const handleOpenTuneViolinModal = () => {
    setShowTuneViolinModal(true);
    setShowBeginModal(false);
  }

  const handleCloseTuneViolinModal = () => {
    setShowTuneViolinModal(false);
    setShowBeginModal(true);
  }

  return (
    <>
      <SEO pageName="sightPlay" />
      <Typography variant='h5' className='pitchTestsPageTitle'>{pitchTestMegaData[levelIndex].pitchTestTitle}</Typography>
      <br/>
      <Typography variant='body1' className='pitchTestsPageTitle'>Boost your sight-reading and intonation using SightPlay Challenge - see how many notes you can get right!</Typography>
      {!!showBeginModal && levelIndex === 0 &&
        <PitchTestsBeginModal 
          numQuestions={NumQuestionsPerLevel} 
          showBeginModal={showBeginModal}
          handleOpenTuneViolinModal={handleOpenTuneViolinModal}
          setShowBeginModal={setShowBeginModal}
          totalNumLevels={pitchTestMegaData.length}
        />}
      {!!showTuneViolinModal && 
        <TuneViolinModal 
          showTuneViolinModal={showTuneViolinModal} 
          handleCloseTuneViolinModal={handleCloseTuneViolinModal}
        />}
      {!showBeginModal && !showTuneViolinModal &&
        <PitchTestSession
          pitchTestLevelData={pitchTestMegaData[levelIndex]}
          levelIndex={levelIndex}
          setLevelIndex={setLevelIndex}
          isLastLevel={pitchTestMegaData.length === (levelIndex + 1)}
          NumQuestionsPerLevel={NumQuestionsPerLevel}
        />
      }
    </>
  )
}

export default PitchTestPage;